import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

(function () {
  const quoteSliders = document.querySelectorAll(".com-quotes__slider");

  let quotesSwiper = [];

  for (let i = 0; i < quoteSliders.length; i++) {
    // const navigationWrapper = swiperSliders[i]
    //   .closest(".com-image-slider")
    //   .querySelector(".swiper-navigation");
    // const nextEl = navigationWrapper.querySelector(".swiper-button-next");
    // const prevEl = navigationWrapper.querySelector(".swiper-button-prev");
    let numSlidesPerView = 1;
    let numSlidesPerView600 = 2;
    let numSlidesPerView900 = 2;
    let numSlidesPerView1200 = 2;
    let numSlidesPerView1600 = 3;
    let speedAutoplay = 6000;

    if (quoteSliders[i].classList.contains("customers")) {
      numSlidesPerView = 1;
      numSlidesPerView600 = 1.3;
      numSlidesPerView900 = 1.5;
      numSlidesPerView1200 = 2;
      numSlidesPerView1600 = 2;
      speedAutoplay = 30000;
    }
    
    quotesSwiper[i] = new Swiper(quoteSliders[i], {
      modules: [Autoplay, Pagination],
      loop: true,
      slidesPerView: numSlidesPerView,
      spaceBetween: 15,
      centeredSlides: true,
      autoplay: {
        delay: speedAutoplay,
        pauseOnMouseEnter: true,
        disableOnInteraction: true,
      },
      //   navigation: {
      //     nextEl: nextEl,
      //     prevEl: prevEl,
      //   },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      },
      breakpoints: {
        600: {
          slidesPerView: numSlidesPerView600,
          spaceBetween: 20,
        },
        900: {
          slidesPerView: numSlidesPerView900,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: numSlidesPerView1200,
          spaceBetween: 50,
        },
        1600: {
          slidesPerView: numSlidesPerView1600,
          spaceBetween: 50,
        },
      },
    });
  }
})();
